import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import SuspendSubModal from './SuspendSubModal';
import { suspendAttSub, findAttSub } from 'actions/attSubs';
import { getIsAdmin } from 'reducers';
import { suspendAttSubscriptionOptions } from 'api';

const mapStateToProps = (state) => {
  const selector = formValueSelector('suspendForm');
  return {
    isAdmin: getIsAdmin(state),
    suspensionStatus: selector(state, 'suspension_status'),
    fetchSuspensionOptions: suspendAttSubscriptionOptions,
  };
};

const mapDispatchToProps = {
  suspendSub: suspendAttSub,
  findSub: findAttSub,
};

const SuspendAttSubModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuspendSubModal);

export default SuspendAttSubModal;
